import { visibleCatalog, type IdeaId } from '../../core/catalog';
import ListingVisibilityBadge from './ListingVisibilityBadge';
import type { IdeaListings } from './types';

/** PostHog ids for the staff badge's "View visibility flag" link. */
const IDEA_FLAG_IDS: Record<IdeaId, number> = { news: 911641 };

/**
 * Products that are still ideas: a name, a sentence, and no link. Each is listed by its own
 * flag, so the card is a place to think out loud, not a promise.
 */
export default function PreviewIdeas({ ideas, showVisibilityDetails }: { ideas: IdeaListings; showVisibilityDetails: boolean }) {
  const visibility = Object.fromEntries(Object.entries(ideas).map(([id, listing]) => [id, listing.visible]));
  const listed = visibleCatalog(visibility).filter(entry => entry.size === 'idea');
  if (listed.length === 0) return null;
  return (
    <section className="preview-tools preview-ideas" aria-labelledby="preview-ideas-heading">
      <div className="preview-section-heading"><h2 id="preview-ideas-heading">On the drawing board.</h2><p>Ideas with a name and nothing behind them yet.</p></div>
      <div className="preview-tool-grid">
        {listed.map(idea => {
          const id = idea.id as IdeaId;
          return (
            <article className="preview-tool" key={id} aria-labelledby={`${id}-heading`}>
              <span className="preview-tool-icon" aria-hidden="true">✎</span>
              <div>
                <span className="preview-badge">Idea</span>
                <h3 id={`${id}-heading`}>{idea.name}</h3>
                {showVisibilityDetails && <ListingVisibilityBadge audience={ideas[id]?.audience ?? 'unknown'} flagId={IDEA_FLAG_IDS[id]} />}
                <p>{idea.description}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
